export const PAGE_SIZE = 20;

export const TEAM_ADMIN_DELETE_MSG =
  'In order to delete a team, you must first delete or reassign any team admins.';
